import { apiClient } from '../api'

export interface PwxMasterSummary {
  id: number
  code: string
  name: string
  description: string | null
  country_code: string | null
  /**
   * Names of the systems that consume this master (e.g.
   * ['lightspeed', 'skimmer']). `null` means the master list applies to
   * every system.
   */
  used_by: string[] | null
  is_hierarchical: boolean
  is_active: boolean
  value_count: number
}

export interface PwxMasterValue {
  id: number
  master_id: number
  parent_id: number | null
  value: string
  display_name: string | null
  attributes: Record<string, unknown> | null
  sort_order: number
  is_active: boolean
}

export interface PwxMasterListResponse {
  items: PwxMasterSummary[]
  total: number
}

export interface PwxMasterValueListResponse {
  items: PwxMasterValue[]
  total: number
  master: PwxMasterSummary
}

export interface ListPwxMastersParams {
  country_code?: string
  /**
   * Filter to masters whose `used_by` array contains this system name.
   * Rows with `used_by = null` (global) match every filter value.
   */
  used_by?: string
  is_active?: boolean
}

export const pwxMastersApi = {
  list: async (
    params: ListPwxMastersParams = {},
  ): Promise<PwxMasterListResponse> => {
    const search = new URLSearchParams()
    if (params.country_code) search.append('country_code', params.country_code)
    if (params.used_by) search.append('used_by', params.used_by)
    if (params.is_active !== undefined) search.append('is_active', String(params.is_active))
    const qs = search.toString()
    const url = qs
      ? `/admin/pwx-masters?${qs}`
      : '/admin/pwx-masters'
    const response = await apiClient.get(url)
    return response.data
  },

  values: async (
    masterId: number,
    includeInactive = false,
  ): Promise<PwxMasterValueListResponse> => {
    const url = includeInactive
      ? `/admin/pwx-masters/${masterId}/values?include_inactive=true`
      : `/admin/pwx-masters/${masterId}/values`
    const response = await apiClient.get(url)
    return response.data
  },
}
